// extracted by mini-css-extract-plugin
export default {"main":"styles_main__4VjJL","img":"styles_img__W-Z+a","container":"styles_container__bWNft"};